import { Route, Routes, useNavigate } from "react-router-dom";

import { ScrollablePane, Stack, useTheme } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { useSoftwarePackages } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { SoftwarePackageVersionsPage } from "./software-package-versions/SoftwarePackageVersionsPage";
import { SoftwareSearchTable } from "./SoftwareSearchTable";

interface SoftwarePackagesHostProps {}

const SoftwarePackagesList = () => {
  const theme = useTheme();
  const { data: softwarePackagesData } = useSoftwarePackages();
  const navigate = useNavigate();

  const handleOpenVersions = (id: string) => {
    navigate(id);
  };

  return (
    <Stack
      verticalFill
      styles={{
        root: { padding: theme.spacing.s1, width: "100%" }
      }}
      tokens={{ childrenGap: theme.spacing.m }}
    >
      <SectionTitle>Software Packages</SectionTitle>

      <ScrollablePane
        styles={{ root: { height: "90%", position: "relative" } }}
      >
        <SoftwareSearchTable
          items={softwarePackagesData || []}
          onOpenVersions={handleOpenVersions}
        />
      </ScrollablePane>
    </Stack>
  );
};

export const SoftwarePackagesScreen: React.FC<SoftwarePackagesHostProps> = ({}) => {
  return (
    <Routes>
      <Route
        path=":softwarePackageId"
        element={<SoftwarePackageVersionsPage />}
      />
      <Route path="*" element={<SoftwarePackagesList />} />
    </Routes>
  );
};
